import { render } from "./IconMultiviewLockedPlaceholderImage.vue?vue&type=template&id=24fd98f1"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconMultiviewLockedPlaceholderImage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "24fd98f1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('24fd98f1', __exports__)) {
    api.reload('24fd98f1', __exports__)
  }
  
  module.hot.accept("./IconMultiviewLockedPlaceholderImage.vue?vue&type=template&id=24fd98f1", () => {
    api.rerender('24fd98f1', render)
  })

}


export default __exports__